<template>
  <div>
    <div class="row">
      <b>Supply Number: {{ headers["Supply Number"] }}</b>
    </div>
    <br>

    <div class="row">
      <div class="col-md-4 text-left">
        <p class="title">{{ headers["client"] }}</p>
        <p class="title">{{ headers["title"] }}</p>
        <p>Season: {{ headers["Season"] }} </p>
        <p>{{ headers["comp_address"] }}</p>
        <p>{{ headers["comp_contact"] }}</p>
        <p>Key Vet: {{ headers["Key vet"] }}</p>
        <p>Zone: {{ headers["Zone"] }}</p>
      </div>

      <div class="col-md-4">
        <p>{{ headers["infotext"] }}</p>
      </div>

      <div class="col-md-4 text-right">
        <p>{{ headers["client"] }}</p>
        <p>{{ headers["Shed Address"] }}</p>
        <p>Consult Date: {{ headers["Consult Date"] }}</p>
        <p>Date of expiry of Authorisation: {{ headers["Date of expiry of authorisation"] }}</p>
        <p>Period of intended use: {{ headers["Period of intended use"] }}</p>
        <p>Period of intended use (DCAT & ITS): {{ headers["Period of intended use (DCAT)"] }}</p>
        <p>Period of intended use (CIA): 4 months from date of allocation</p>
      </div>
    </div>
    <br>

    <div class="row">
      <table class="table">
        <thead>
          <tr>
            <th width="7%">Drug Name</th>
            <th width="13%">Active Ingredient & Concentration</th>
            <th width="15%">Drug Use</th>
            <th width="15">Stock Classes</th>
            <th width="5%">Authorised Quantity</th>
            <th width="10%">Allocation Period</th>
            <th width="5%">Dose Rate/Interval</th>
            <th width="5%">Route</th>
            <th width="5%">Milk WHP (from last treatment)</th>
            <th width="6%">Meat WHP (from last treatment)</th>
            <th width="14%">Additional Instructions</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(groupDrugs, groupName, groupIndex) in groups">
            <tr class="group-name" :key="groupIndex+'_first_table_row'">
              <td>{{ groupName }} </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr v-for="(drug, drugIndex) in groupDrugs" :key="groupIndex+groupName+drugIndex">
              <td>{{ drug["Drug Name"] }}</td>
              <td>{{ drug["Active Ingredient & Concentration"] }}</td>
              <td><b>{{ drug["Drug Use"] }}</b></td>
              <td>{{ drug["Stock Classes"] }}</td>
              <td>{{ drug["Authorised Quantity"] }}</td>
              <td>{{ drug["Allocation Period"] }}</td>
              <td>{{ drug["Dose rate / Interval"] }}</td>
              <td>{{ drug["Route"] }}</td>
              <td>{{ drug["WHP Milk"] }}</td>
              <td>{{ drug["WHP Meat"] }}</td>
              <td>{{ drug["Additional Instructions"] }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'headers',
    'groups',
  ],
};
</script>

<style scoped>
span.blocked {
  display: block;
}
tr.group-name {
  background-color: rgb(54, 173, 122);
  font-size: 1.15em;
  font-weight: bold;
}
td {
  text-align: left;
  padding: 4px !important;
}
th {
  font-weight: normal;
}
p.title {
  font-size: 20px;
}

@media (min-width: 992px)
.container {
    width: 1170px !important;
}
@media (min-width: 1200px)
.container {
    width: 1370px !important;
}
</style>
